import { useState } from 'react';
import { Box, List, ListItem, Typography } from '@material-ui/core';

import { orderDetailDisclaimer } from '../orderDetailDisclaimer.styles';
import { OrderMgmtDisclaimer } from '../../../../../business/order-mgmt';
import { useOrderDetailDisclaimerLang } from '../hooks';
import collapseIcon from '../../../../../../src/assets/images/icons/collapse.svg';
import questionIcon from '../../../../../../src/assets/images/icons/question_icon.svg';

export function ToAcceptedDisclaimer({
  orderChanges: orders,
  hasToppings,
}: Props) {
  const [isContentCollapsed, setIsContentCollapsed] = useState(false);
  const styles = orderDetailDisclaimer({ isContentCollapsed });
  const showCollapseIcon = orders.length > 1;

  function handleContentCollapse() {
    setIsContentCollapsed(collapse => !collapse);
  }
  const { disclaimerDoubtsText, chatText } = useOrderDetailDisclaimerLang();

  return (
    <>
      <Box
        className={styles.container}
        display='flex'
        flexDirection='column'
        position='relative'
        padding='0.5rem 1rem'
      >
        {showCollapseIcon && (
          <img
            className={styles.collapseIcon}
            src={collapseIcon}
            alt='collapse-icon'
            onClick={handleContentCollapse}
          />
        )}
        <Box display='flex' flexDirection='column' gridGap='0.75rem'>
          {[...(isContentCollapsed ? orders.slice(0, 1) : orders)].map(
            changed => (
              <ChangedProduct
                changedProduct={changed}
                key={`om-changed-${changed.id}`}
              />
            ),
          )}
          {hasToppings && (
            <Box display='flex' alignItems='center' gridGap='0.25rem'>
              <img src={questionIcon} />
              <Typography className={styles.quaternaryText}>
                {disclaimerDoubtsText}
                <span className={styles.underline}>{chatText}</span>
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
}

interface Props {
  orderChanges: OrderMgmtDisclaimer[];
  hasToppings: boolean;
}

function ChangedProduct({ changedProduct }) {
  const styles = orderDetailDisclaimer();
  const {
    acceptedUserSuggestionChangesText,
    thisProductWasTurnedOffAutomaticallyText,
  } = useOrderDetailDisclaimerLang(changedProduct);

  return (
    <Box className={styles.content}>
      <Box
        flex={1}
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        marginRight='2rem'
      >
        <Typography className={styles.primaryText}>
          {acceptedUserSuggestionChangesText}
        </Typography>
      </Box>
      <Box display='flex' gridGap='0.5rem' alignItems='center'>
        <List className={styles.itemContainer}>
          <ListItem className={styles.secondaryText}>
            {thisProductWasTurnedOffAutomaticallyText}
          </ListItem>
        </List>
      </Box>
    </Box>
  );
}
